import { PromoType } from "@/types/global";
import ConfigService from "./ConfigService";

const ON_USER_DEFAULT_PICKS = "ON_USER_DEFAULT_PICKS";
const ON_USER_PICK = "ON_USER_PICK";
const ON_USER_SIGN_IN = "ON_USER_SIGN_IN";
const ACK_USER_SIGN_OUT = "ACK_USER_SIGN_OUT";
const ON_SESSION_EXPIRED = "ON_SESSION_EXPIRED";
const ON_LIVE_CHAT_CLICK = "ON_LIVE_CHAT_CLICK";
const ON_TOKEN_EXPIRY_WARNING = "ON_TOKEN_EXPIRY_WARNING";
const TOKEN_REFRESH = "TOKEN_REFRESH";
const ON_WIDGET_BACK = "ON_WIDGET_BACK";
const ON_WIDGET_CLOSE = "ON_WIDGET_CLOSE";
const ON_FREE_SPIN_EXCHANGE_REQUEST = "ON_FREE_SPIN_EXCHANGE_REQUEST";
const ON_GAME_CLICK = "ON_GAME_CLICK";
const ON_PLAY_CLICK = "ON_PLAY_CLICK";
const MODAL_OPEN = "modal:open";
const MODAL_CLOSE = "modal:close";

function PostUserSignInMsg(type: PromoType) {
  let PROMOTION_ROUTE;
  switch (type) {
    case PromoType.CASINO:
      PROMOTION_ROUTE = "/casino/game";
      break;
    case PromoType.F2P:
      PROMOTION_ROUTE = "/f2p/game/pickem";
      break;
    default:
      PROMOTION_ROUTE = "";
      break;
  }

  return {
    event: ON_USER_SIGN_IN,
    data: {
      path: PROMOTION_ROUTE,
      promoId: ConfigService.getPromoId(),
    },
  };
}

function AckUserSignOut() {
  return {
    event: ACK_USER_SIGN_OUT,
  };
}

function PostSessionExpiredMsg(reason: string = "401_unauthorized") {
  return {
    event: ON_SESSION_EXPIRED,
    data: {
      reason: reason,
      timestamp: Date.now(),
      promoId: ConfigService.getPromoId(),
    },
  };
}

function PostUserPickMsg(weekId: string, propId: number, option: any) {
  return {
    event: ON_USER_PICK,
    payload: {
      weekId: weekId,
      propId: propId,
      value: option.value,
    },
  };
}

function PostLiveChatClickMsg() {
  return {
    event: ON_LIVE_CHAT_CLICK,
    data: {
      promoId: ConfigService.getPromoId(),
      timestamp: Date.now(),
    },
  };
}

function PostTokenExpiryWarningMsg() {
  return {
    event: ON_TOKEN_EXPIRY_WARNING,
    data: {
      promoId: ConfigService.getPromoId(),
      timestamp: Date.now(),
    },
  };
}

// Mini-widget header controls. The host decides what back/close mean for its
// own chrome — the widget only reports the intent.
function PostWidgetBackMsg() {
  return {
    event: ON_WIDGET_BACK,
    data: {
      promoId: ConfigService.getPromoId(),
      timestamp: Date.now(),
    },
  };
}

function PostWidgetCloseMsg() {
  return {
    event: ON_WIDGET_CLOSE,
    data: {
      promoId: ConfigService.getPromoId(),
      timestamp: Date.now(),
    },
  };
}

// Free Spin Module promos hand the whole exchange flow to the host page: the widget
// never opens its own exchange modal, it only reports that the user asked to exchange.
function PostFreeSpinExchangeRequestMsg() {
  return {
    event: ON_FREE_SPIN_EXCHANGE_REQUEST,
    data: {
      promoId: ConfigService.getPromoId(),
      timestamp: Date.now(),
    },
  };
}

function PostGameClickMsg(url: string) {
  return {
    event: ON_GAME_CLICK,
    data: { url },
  };
}

function PostPlayClickMsg(url: string) {
  return {
    event: ON_PLAY_CLICK,
    data: { url },
  };
}

function PostModalOpenMsg() {
  return { type: MODAL_OPEN };
}

function PostModalCloseMsg() {
  return { type: MODAL_CLOSE };
}

export {
  ON_USER_DEFAULT_PICKS,
  ON_USER_PICK,
  ON_USER_SIGN_IN,
  ACK_USER_SIGN_OUT,
  ON_SESSION_EXPIRED,
  ON_LIVE_CHAT_CLICK,
  ON_TOKEN_EXPIRY_WARNING,
  TOKEN_REFRESH,
  ON_WIDGET_BACK,
  ON_WIDGET_CLOSE,
  ON_FREE_SPIN_EXCHANGE_REQUEST,
  ON_GAME_CLICK,
  ON_PLAY_CLICK,
  PostWidgetBackMsg,
  PostWidgetCloseMsg,
  PostUserPickMsg,
  PostUserSignInMsg,
  AckUserSignOut,
  PostSessionExpiredMsg,
  PostLiveChatClickMsg,
  PostTokenExpiryWarningMsg,
  PostFreeSpinExchangeRequestMsg,
  PostGameClickMsg,
  PostPlayClickMsg,
  PostModalOpenMsg,
  PostModalCloseMsg,
};
